import { ManagerNickName } from '../managers/managers';

export default function getManagerEmail(managerId: number, managersNickName: ManagerNickName[]) {
    const manager = managerId ? managersNickName.find((name) => name.id === managerId.toString()) : null;
    if (manager) {
        return manager.email;
    }
    return managerId;
}
